/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetCustomDefaultLeadViewSetting404Response } from '../models';
// @ts-ignore
import { GetProductCategories200Response } from '../models';
// @ts-ignore
import { PostProductCategoryRequest } from '../models';
// @ts-ignore
import { ProductCategory } from '../models';
/**
 * ProductCategoryApi - axios parameter creator
 * @export
 */
export const ProductCategoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 商材カテゴリ一覧取得API
         * @summary 商材カテゴリ一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCategories: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/product_categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 商材カテゴリ作成API
         * @summary 商材カテゴリ作成API
         * @param {PostProductCategoryRequest} postProductCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postProductCategory: async (postProductCategoryRequest: PostProductCategoryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postProductCategoryRequest' is not null or undefined
            assertParamExists('postProductCategory', 'postProductCategoryRequest', postProductCategoryRequest)
            const localVarPath = `/api/user/product_categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postProductCategoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 商材カテゴリ更新API
         * @summary 商材カテゴリ更新API
         * @param {number} productCategoryId 商材カテゴリID
         * @param {PostProductCategoryRequest} postProductCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putProductCategory: async (productCategoryId: number, postProductCategoryRequest: PostProductCategoryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productCategoryId' is not null or undefined
            assertParamExists('putProductCategory', 'productCategoryId', productCategoryId)
            // verify required parameter 'postProductCategoryRequest' is not null or undefined
            assertParamExists('putProductCategory', 'postProductCategoryRequest', postProductCategoryRequest)
            const localVarPath = `/api/user/product_categories/{productCategoryId}`
                .replace(`{${"productCategoryId"}}`, encodeURIComponent(String(productCategoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postProductCategoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductCategoryApi - functional programming interface
 * @export
 */
export const ProductCategoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductCategoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 商材カテゴリ一覧取得API
         * @summary 商材カテゴリ一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductCategories(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProductCategories200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductCategories(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 商材カテゴリ作成API
         * @summary 商材カテゴリ作成API
         * @param {PostProductCategoryRequest} postProductCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postProductCategory(postProductCategoryRequest: PostProductCategoryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductCategory>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postProductCategory(postProductCategoryRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 商材カテゴリ更新API
         * @summary 商材カテゴリ更新API
         * @param {number} productCategoryId 商材カテゴリID
         * @param {PostProductCategoryRequest} postProductCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putProductCategory(productCategoryId: number, postProductCategoryRequest: PostProductCategoryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putProductCategory(productCategoryId, postProductCategoryRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductCategoryApi - factory interface
 * @export
 */
export const ProductCategoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductCategoryApiFp(configuration)
    return {
        /**
         * 商材カテゴリ一覧取得API
         * @summary 商材カテゴリ一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCategories(options?: any): AxiosPromise<GetProductCategories200Response> {
            return localVarFp.getProductCategories(options).then((request) => request(axios, basePath));
        },
        /**
         * 商材カテゴリ作成API
         * @summary 商材カテゴリ作成API
         * @param {PostProductCategoryRequest} postProductCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postProductCategory(postProductCategoryRequest: PostProductCategoryRequest, options?: any): AxiosPromise<ProductCategory> {
            return localVarFp.postProductCategory(postProductCategoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 商材カテゴリ更新API
         * @summary 商材カテゴリ更新API
         * @param {number} productCategoryId 商材カテゴリID
         * @param {PostProductCategoryRequest} postProductCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putProductCategory(productCategoryId: number, postProductCategoryRequest: PostProductCategoryRequest, options?: any): AxiosPromise<void> {
            return localVarFp.putProductCategory(productCategoryId, postProductCategoryRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductCategoryApi - interface
 * @export
 * @interface ProductCategoryApi
 */
export interface ProductCategoryApiInterface {
    /**
     * 商材カテゴリ一覧取得API
     * @summary 商材カテゴリ一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductCategoryApiInterface
     */
    getProductCategories(options?: AxiosRequestConfig): AxiosPromise<GetProductCategories200Response>;

    /**
     * 商材カテゴリ作成API
     * @summary 商材カテゴリ作成API
     * @param {PostProductCategoryRequest} postProductCategoryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductCategoryApiInterface
     */
    postProductCategory(postProductCategoryRequest: PostProductCategoryRequest, options?: AxiosRequestConfig): AxiosPromise<ProductCategory>;

    /**
     * 商材カテゴリ更新API
     * @summary 商材カテゴリ更新API
     * @param {number} productCategoryId 商材カテゴリID
     * @param {PostProductCategoryRequest} postProductCategoryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductCategoryApiInterface
     */
    putProductCategory(productCategoryId: number, postProductCategoryRequest: PostProductCategoryRequest, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for postProductCategory operation in ProductCategoryApi.
 * @export
 * @interface ProductCategoryApiPostProductCategoryRequest
 */
export interface ProductCategoryApiPostProductCategoryRequest {
    /**
     * 
     * @type {PostProductCategoryRequest}
     * @memberof ProductCategoryApiPostProductCategory
     */
    readonly postProductCategoryRequest: PostProductCategoryRequest
}

/**
 * Request parameters for putProductCategory operation in ProductCategoryApi.
 * @export
 * @interface ProductCategoryApiPutProductCategoryRequest
 */
export interface ProductCategoryApiPutProductCategoryRequest {
    /**
     * 商材カテゴリID
     * @type {number}
     * @memberof ProductCategoryApiPutProductCategory
     */
    readonly productCategoryId: number

    /**
     * 
     * @type {PostProductCategoryRequest}
     * @memberof ProductCategoryApiPutProductCategory
     */
    readonly postProductCategoryRequest: PostProductCategoryRequest
}

/**
 * ProductCategoryApi - object-oriented interface
 * @export
 * @class ProductCategoryApi
 * @extends {BaseAPI}
 */
export class ProductCategoryApi extends BaseAPI implements ProductCategoryApiInterface {
    /**
     * 商材カテゴリ一覧取得API
     * @summary 商材カテゴリ一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductCategoryApi
     */
    public getProductCategories(options?: AxiosRequestConfig) {
        return ProductCategoryApiFp(this.configuration).getProductCategories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 商材カテゴリ作成API
     * @summary 商材カテゴリ作成API
     * @param {ProductCategoryApiPostProductCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductCategoryApi
     */
    public postProductCategory(requestParameters: ProductCategoryApiPostProductCategoryRequest, options?: AxiosRequestConfig) {
        return ProductCategoryApiFp(this.configuration).postProductCategory(requestParameters.postProductCategoryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 商材カテゴリ更新API
     * @summary 商材カテゴリ更新API
     * @param {ProductCategoryApiPutProductCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductCategoryApi
     */
    public putProductCategory(requestParameters: ProductCategoryApiPutProductCategoryRequest, options?: AxiosRequestConfig) {
        return ProductCategoryApiFp(this.configuration).putProductCategory(requestParameters.productCategoryId, requestParameters.postProductCategoryRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
